import { Injectable, inject } from '@angular/core';
import { EventType, NavigationEnd, Router } from '@angular/router';
import { DelayedBehaviorSubject } from '@forgerock/backstage-ui-core';
import { filter, map } from 'rxjs';
import { AppSearchParamsInt } from '../model/app-search-params';
import { SearchParamsMapperService } from './search-params-mapper.service';

/**
 * RouteParamsAdapterService provides a boundary between the route params and the application state
 * It translates between query params and search params and resolves th current tab.
 */
@Injectable({
  providedIn: 'root'
})
export class SearchParamsAdapterService {
  private router = inject(Router);
  private mapper = inject(SearchParamsMapperService);


  params: DelayedBehaviorSubject<AppSearchParamsInt> = new DelayedBehaviorSubject();

  constructor() {
    const router = this.router;

    router.events
      .pipe(
        filter<NavigationEnd>(event => event.type === EventType.NavigationEnd),
        map(({ url }) => this.router.parseUrl(url).queryParams)
      )
      .subscribe({
        next: async params => this.params.next(await this.mapper.toSearchParamsInt(params))
      });
  }

  /**
   * Set the query params by triggering navigation.
   * We must make sure that this doesn't cause an event loop as navigation events cause
   * the {@link searchParams} and {@link tab} observables to emit new values.
   */
  updateQueryParams(params: Partial<AppSearchParamsInt>): Promise<boolean> {
    return this.router.navigate([], {
      queryParams: this.mapper.toSearchParamsExt(params)
    });
  }

}

